import type { Route } from "@angular/router";

import { checkIfLoggedInFn, notExternalOrParticipatingEntity } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { ImportExportObjectType, PageMode } from "../../shared/constants/enums";
import {
  auditIssuesViewAccessGuard,
  kpiEntityTypeGuard,
  kpiPMOGuard,
  kpiTypeCloneAccessGuard,
  kpiTypeCreateAccessGuard,
  kpiTypeEditAccessGuard,
  kpiTypeViewAccessGuard,
  viewImportExportKpiPagesGuards,
} from "./kpi-utils";

export const KPI_ROUTES: Route[] = [
  {
    path: "kpi",
    children: [
      {
        path: "import-export-kpi",
        canActivate: [checkIfLoggedInFn, notExternalOrParticipatingEntity, ...viewImportExportKpiPagesGuards],
        data: {
          breadcrumb: "importExport.title_kpi",
          title: "importExport.title_kpi",
          type: ImportExportObjectType.KPI,
        },
        loadComponent: () =>
          import("../../shared/components/import-export/import-export").then((e) => e.ImportExportComponent),
      },
      {
        path: "",
        component: SubmenuComponent,
        canActivate: [checkIfLoggedInFn],
        data: {
          title: "kpi.kpis",
          breadcrumb: "kpi.kpis",
        },
      },
      {
        path: "audit-issues",
        loadComponent: () => import("./audit-issues/audit-issues").then((e) => e.AuditIssuesComponent),
        canActivate: [checkIfLoggedInFn, ...auditIssuesViewAccessGuard],
        data: {
          title: "breadcrumbs.audit_issue",
          breadcrumb: "breadcrumbs.audit_issue",
        },
      },
      {
        path: ":kpiType",
        children: [
          {
            path: "",
            loadComponent: () => import("./kpi-list/kpi-list").then((e) => e.KpiListComponent),
            canActivate: [checkIfLoggedInFn, kpiPMOGuard, kpiEntityTypeGuard, kpiTypeViewAccessGuard],
            data: {
              title: "kpi.kpis",
              breadcrumb: {
                alias: "kpisList",
              },
            },
          },
          {
            path: "edit/:kpiId",
            loadComponent: () => import("./kpi-editor/kpi-editor").then((e) => e.KpiEditorComponent),
            canActivate: [checkIfLoggedInFn, kpiEntityTypeGuard, kpiTypeEditAccessGuard],
            data: {
              title: "kpi.kpis",
              breadcrumb: {
                alias: "kpiEditor",
              },
              pageMode: PageMode.edit,
            },
          },
          {
            path: "clone/:kpiId",
            loadComponent: () => import("./kpi-editor/kpi-editor").then((e) => e.KpiEditorComponent),
            canActivate: [checkIfLoggedInFn, kpiEntityTypeGuard, kpiTypeCloneAccessGuard],
            data: {
              title: "kpi.kpis",
              breadcrumb: {
                alias: "kpiClone",
              },
              pageMode: PageMode.edit,
              isClone: true,
            },
          },
          {
            path: "create",
            loadComponent: () => import("./kpi-editor/kpi-editor").then((e) => e.KpiEditorComponent),
            canActivate: [checkIfLoggedInFn, kpiEntityTypeGuard, kpiTypeCreateAccessGuard],
            data: {
              title: "kpi.kpis",
              breadcrumb: {
                alias: "kpiEditor",
              },
              pageMode: PageMode.create,
            },
          },
          {
            path: ":kpiId",
            loadComponent: () => import("./kpi-view/kpi-view").then((e) => e.KpiViewComponent),
            canActivate: [checkIfLoggedInFn, kpiTypeViewAccessGuard],
            data: {
              title: "kpi.kpis",
              breadcrumb: {
                alias: "kpisView",
              },
            },
          },
        ],
      },
    ],
  },
];
